import React from 'react';
import './App.css';
import Heading from "./components/heading";
import Form from "./components/form";
import Forecast from "./components/forecast";
import { HashRouter, Route, Link } from "react-router-dom";

const api_key = "a79fe240776d4aaf946f0423c5d6960d";

class App extends React.Component {
  state = {
    temperature: "",
    city: "",
    country: "",
    humidity: "",
    pressure: "",
    icon: "",
    description: "",
    error: ""
  }
  getWeather = async (e) => {
    const city = e.target.elements.city.value;
    const country = e.target.elements.country.value;
    e.preventDefault();
    const api_call = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&units=imperial&appid=${api_key}`);

    const response = await api_call.json();

    if (city && country) {
      this.setState({
        temperature: response.main.temp,
        city: response.main.city,
        country: response.main.country,
        humidity: response.main.humidity,
        pressure: response.main.pressure,
        icon: response.weather[0].icon,
        description: response.weather[0].description,
        error: ""
      })
    } else {
      this.setState({
        error: "Please fill out input fields..."
      })
    }
  }
  render() {
    return (
      <div className="container">
        <Heading />
        <div className="form">
          <Form loadWeather={this.getWeather} />
        </div>
        <div className="weather">
          <Forecast
            temperature={this.state.temperature}
            city={this.state.city}
            country={this.state.country}
            humidity={this.state.humidity}
            pressure={this.state.pressure}
            icon={this.state.icon}
            description={this.state.description}
            error={this.state.error}
          />
        </div>
        <HashRouter basename="/">
          <div>
            <hr />

            <Route exact path="/" component={Home} />
            <Route path="/about" component={About} />
          </div>
        </HashRouter>
      </div>
    );
  }
}


const Home = () => <div><h2>Home</h2></div>
const About = () => <div><h2>About</h2></div>

export default App;
